(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[495],{

/***/ 10922:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/register",
      function () {
        return __webpack_require__(78552);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ register; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./lib/withPage.js
var withPage = __webpack_require__(68262);
// EXTERNAL MODULE: ./src/bigcommerce/api/api-client.js + 1 modules
var api_client = __webpack_require__(37162);
;// CONCATENATED MODULE: ./src/bigcommerce/api/customers/create-customer.js



var createCustomer = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var email, password, firstName, lastName, phoneNumber, requestBody, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    email = param.email, password = param.password, firstName = param.firstName, lastName = param.lastName, phoneNumber = param.phoneNumber;
                    requestBody = {
                        email: email,
                        password: password,
                        firstName: firstName,
                        lastName: lastName,
                        phoneNumber: phoneNumber
                    };
                    return [
                        4,
                        (0,api_client/* api */.h)("/customer/create", {
                            method: "POST",
                            body: JSON.stringify(requestBody)
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (response.code != 200) {
                        if (response.code == 422) {
                            throw new Error("Email is already registered");
                        } else {
                            throw new Error("Unexpected error");
                        }
                    }
                    return [
                        2
                    ];
            }
        });
    });
    return function createCustomer(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/components/home/breadcrumb.jsx
var breadcrumb = __webpack_require__(89075);
// EXTERNAL MODULE: ./src/components/page.jsx + 1 modules
var page = __webpack_require__(13366);
// EXTERNAL MODULE: ./src/redux/actions/customer.js + 1 modules
var customer = __webpack_require__(86303);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
var parsePhoneNumber = __webpack_require__(25631);
// EXTERNAL MODULE: ./node_modules/libphonenumber-js/min/exports/findPhoneNumbersInText.js + 11 modules
var findPhoneNumbersInText = __webpack_require__(96981);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var dist = __webpack_require__(86501);
// EXTERNAL MODULE: ./node_modules/simple-react-validator/dist/simple-react-validator.min.js
var simple_react_validator_min = __webpack_require__(41283);
var simple_react_validator_min_default = /*#__PURE__*/__webpack_require__.n(simple_react_validator_min);
;// CONCATENATED MODULE: ./pages/register.jsx




















var Register = /*#__PURE__*/ function(Page) {
    "use strict";
    (0,_inherits/* default */.Z)(Register, Page);
    var _super = (0,_create_super/* default */.Z)(Register);
    function Register(props) {
        (0,_class_call_check/* default */.Z)(this, Register);
        var _this;
        _this = _super.call(this, props);
        _this.signUp = _this.signUp.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.inputs = {};
        _this._validateOnDemand = true;
        _this.validator = new (simple_react_validator_min_default())({
            locale: "en"
        });
        _this.validationCheck = _this.validationCheck.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(Register, [
        {
            key: "validationCheck",
            value: function validationCheck(target) {
                this.inputs[target.target.id] = target.target.value;
                if (!this._validateOnDemand) return;
            }
        },
        {
            key: "signUpAPI",
            value: function signUpAPI(email, password, firstName, lastName, phoneNumber) {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var result, error;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    ,
                                    5
                                ]);
                                return [
                                    4,
                                    createCustomer({
                                        email: email,
                                        password: password,
                                        firstName: firstName,
                                        lastName: lastName,
                                        phoneNumber: phoneNumber
                                    })
                                ];
                            case 1:
                                result = _state.sent();
                                if (!result) return [
                                    3,
                                    3
                                ];
                                return [
                                    4,
                                    _this.props.login({
                                        username: email,
                                        password: password
                                    })
                                ];
                            case 2:
                                _state.sent();
                                _state.label = 3;
                            case 3:
                                return [
                                    3,
                                    5
                                ];
                            case 4:
                                error = _state.sent();
                                {
                                    dist/* default.error */.ZP.error(error.message);
                                // TODO: This would be nice place to log errors to some external service
                                }
                                return [
                                    3,
                                    5
                                ];
                            case 5:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "signUp",
            value: function signUp() {
                var _this = this;
                return (0,_async_to_generator/* default */.Z)(function() {
                    var _inputs, password, email, phone_number, given_name, family_name, googleNumber, parsed;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        _inputs = _this.inputs, password = _inputs.password, email = _inputs.email, phone_number = _inputs.phone_number, given_name = _inputs.given_name, family_name = _inputs.family_name;
                        _this.setState({
                            error: null
                        });
                        if (_this.validator.allValid()) {
                            googleNumber = (0,findPhoneNumbersInText/* findPhoneNumbersInText */.t)(phone_number, "US");
                            if (googleNumber.length > 0) {
                                parsed = (0,parsePhoneNumber/* parsePhoneNumber */.S)(googleNumber[0].number.number);
                                phone_number = parsed ? parsed.number : phone_number;
                            }
                            _this.signUpAPI(email, password, given_name, family_name, phone_number);
                        } else {
                            _this.validator.showMessages();
                            _this.forceUpdate();
                        }
                        return [
                            2
                        ];
                    });
                })();
            }
        },
        {
            key: "signUpSuccess",
            value: function signUpSuccess(username) {
                var _inputs = this.inputs, email = _inputs.email, password = _inputs.password;
                dist/* default.success */.ZP.success("Account Created");
            }
        },
        {
            key: "signUpError",
            value: function signUpError(err) {
                dist/* default.error */.ZP.error(err.message);
                var message = err.message || err;
                if (message.startsWith("Invalid phone number")) {
                    // reference: https://docs.aws.amazon.com/cognito/latest/developerguide/user-pool-settings-attributes.html
                    message = "Phone numbers must follow these formatting rules: A phone number must start with a plus (+) sign, followed immediately by the country code. A phone number can only contain the + sign and digits. You must remove any other characters from a phone number, such as parentheses, spaces, or dashes (-) before submitting the value to the service. For example, a United States-based phone number must follow this format: +14325551212.";
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var user = this.props.user;
                if (!user || !user.email) {
                    user = null;
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                            title: "create account"
                        }),
                        function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    _this.signUp();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "page register",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "account-login-register",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "container",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "login-container",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        children: "Register"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "form-group",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            className: "form-control",
                                                            id: "given_name",
                                                            placeholder: "First Name",
                                                            required: "required",
                                                            onChange: function(target) {
                                                                return _this.validationCheck(target);
                                                            }
                                                        })
                                                    }),
                                                    _this.validator.message("First Name", _this.inputs.given_name, "required|string"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "form-group",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            className: "form-control",
                                                            id: "family_name",
                                                            placeholder: "Last Name",
                                                            required: "required",
                                                            onChange: function(target) {
                                                                return _this.validationCheck(target);
                                                            }
                                                        })
                                                    }),
                                                    _this.validator.message("Last Name", _this.inputs.family_name, "required|string"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "form-group",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "text",
                                                            className: "form-control",
                                                            id: "email",
                                                            placeholder: "Email",
                                                            required: "required",
                                                            onChange: function(target) {
                                                                return _this.validationCheck(target);
                                                            }
                                                        })
                                                    }),
                                                    _this.validator.message("Email", _this.inputs.email, "required|string"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "form-group",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "numeric",
                                                            format: "(###) ###-####",
                                                            className: "form-control",
                                                            id: "phone_number",
                                                            placeholder: "Phone Number",
                                                            required: "required",
                                                            onChange: function(target) {
                                                                return _this.validationCheck(target);
                                                            }
                                                        })
                                                    }),
                                                    _this.validator.message("Phone Number", _this.inputs.phone_number, "required|phone"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "form-group",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                            type: "password",
                                                            className: "form-control",
                                                            id: "password",
                                                            placeholder: "Enter your password",
                                                            required: "required",
                                                            onChange: function(target) {
                                                                return _this.validationCheck(target);
                                                            }
                                                        })
                                                    }),
                                                    _this.validator.message("Password", _this.inputs.password, "required|string"),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                        className: "btn",
                                                        type: "submit",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-user-plus"
                                                            }),
                                                            " Create Account"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "login",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                children: "Already Have Account?"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: "/login",
                                                                as: "/login",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                    className: "btn secondary",
                                                                    children: [
                                                                        "Sign In",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                            className: "far fa-chevron-right",
                                                                            "aria-hidden": "true"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            });
                        }()
                    ]
                });
            }
        }
    ]);
    return Register;
}(page/* default */.Z);
var mapStateToProps = function(state) {
    return {
        user: state.customer
    };
};
var mapDispatchToProps = function(dispatch) {
    return {
        login: function(payload) {
            return dispatch(customer/* login */.x4(payload));
        }
    };
};
/* harmony default export */ var register = ((0,withPage/* default */.ZP)((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(Register)));


/***/ }),

/***/ 89075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var Breadcrumb = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Breadcrumb, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Breadcrumb);
    function Breadcrumb() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Breadcrumb);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Breadcrumb, [
        {
            key: "render",
            value: function render() {
                var title = this.props.title;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "breadcrumb-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "page-title",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                        "aria-label": "breadcrumb",
                                        className: "theme-breadcrumb",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                            className: "breadcrumb",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    href: "/",
                                                    as: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                        className: "breadcrumb-item",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                            href: "/",
                                                            children: "Home"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "breadcrumb-item active",
                                                    "aria-current": "page",
                                                    children: title
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return Breadcrumb;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,6672,8013,1484,3366,9774,2888,179], function() { return __webpack_exec__(10922); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);